import { Fragment, useState } from "react"

import { useQuery, userClient } from "@trueskin-web/apis"
import { Seo, Spinner } from "@trueskin-web/components"
import { useAuth } from "@trueskin-web/context"
import { useTranslation } from "@trueskin-web/translations"

import DataCheckQuestionnaire from "./data-check-questionnaire"
import Intro from "./intro"
import ModernUploadPhotos from "./modern-upload-photos"
import UploadPhotos from "./upload-photos"

const Photos = () => {
  const { t } = useTranslation()

  const { status: dataCheckStatus, data: dataCheck } = useQuery(
    "dataCheck",
    userClient.getDataCheckDetails,
    { cacheTime: 0 }
  )

  const {
    user: { treatmentPlan },
  } = useAuth()

  const [isIntroPageDismissed, setIsIntroPageDismissed] = useState(false)

  if (dataCheckStatus === "loading") {
    return <Spinner isFullPage />
  }

  return (
    <Fragment>
      <Seo title={t("Start.Photos.title")} />

      {dataCheck?.isRequired ? (
        <DataCheckQuestionnaire typeformUrl={dataCheck.typeformUrl} />
      ) : !treatmentPlan ? (
        isIntroPageDismissed ? (
          <ModernUploadPhotos requireTelemedicineAgreement />
        ) : (
          <Intro onDismiss={() => setIsIntroPageDismissed(true)} />
        )
      ) : (
        <UploadPhotos />
      )}
    </Fragment>
  )
}

export default Photos
